var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-layout"},[_c('main',{staticClass:"main-content",class:{ 'with-navbar': _vm.showNavbar }},[_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }